import { Component, AfterViewInit, inject } from '@angular/core';
import {  Router } from '@angular/router';
import { CryptoJsService } from 'src/app/core/services/crypto-js.service';
import { NgOptimizedImage } from "@angular/common";

@Component({
  selector: 'app-not-found',
  standalone: true,
  templateUrl: './not-found.component.html'
})
export class NotfoundComponent implements AfterViewInit {
  ruta: any;

  private routes = inject(Router);
  constructor(
    private _cryptoJsService: CryptoJsService,
  ) {


  }
  ngAfterViewInit() { }

  goHome() {
    const permissionLevel = (this._cryptoJsService.getItem('permissionLevel'));
    if (permissionLevel === 'sales') {
      this.routes.navigate(['/sales/projects-select'], { replaceUrl: true });
    } else if (permissionLevel === 'admin') {
        this.routes.navigate(['/starter'], { replaceUrl: true });
    } 
  }
}
